import { CircularProgress, Box } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import ContentWrapper from '../components/ContentWrapper';
import useConfirmAccount from './hooks/useConfirmAccount';

export default () => {
  const { t } = useTranslation();
  const { isLoading } = useConfirmAccount();

  return (
    <ContentWrapper title={t('components.please_wait')}>
      {isLoading && (
        <Box sx={{ textAlign: 'center', mt: theme => theme.spacing(3) }}>
          <CircularProgress aria-label={t('components.loading_icon')} />
        </Box>
      )}
    </ContentWrapper>
  );
};
